import React, { Component } from 'react';
import moment from 'moment';
import { ButtonV2, Checkbox, DatePicker } from 'components';
import { getDateRange } from 'components/DateFilter/indexV2';
import { openEmptyWindow } from 'lib/utils';
import './style.scss';

class ViewPortfolioV2 extends Component {
  constructor(props) {
    super(props);

    // default to the full previous calendar month
    const prevMonth = moment()
      .subtract(1, 'month')
      .toDate();
    const [defaultStart, defaultEnd] = getDateRange(prevMonth, 'monthly');

    this.state = {
      withProgressOnly: true,
      startDate: moment(defaultStart).format('YYYY-MM-DD'),
      endDate: moment(defaultEnd).format('YYYY-MM-DD'),
      error: ''
    };
  }

  disableDays = day => {
    const momentDay = moment(day);
    const currentMoment = moment();
    const startMoment = moment(this.state.startDate);

    return momentDay.isAfter(currentMoment) || momentDay.isBefore(startMoment);
  };

  disableDaysStart = day => {
    const momentDay = moment(day);
    return momentDay.isAfter(moment(this.state.endDate));
  };

  onStartDateChange = date => {
    this.setState({
      startDate: moment(date).format('YYYY-MM-DD'),
      error: ''
    });
  };

  onEndDateChange = date => {
    this.setState({
      endDate: moment(date).format('YYYY-MM-DD'),
      error: ''
    });
  };

  checkChanged = () => {
    this.setState(state => ({ withProgressOnly: !state.withProgressOnly }));
  };

  onExport = async () => {
    const { startDate, endDate } = this.state;
    const start = moment(startDate);
    const end = moment(endDate);

    if (end.diff(start, 'months', true) > 6) {
      this.setState({ error: 'Cannot use range that exceeds 6 months' });
      return;
    }

    const newWindow = openEmptyWindow();
    if (!newWindow) return;

    const { id } = this.props.data;
    const { withProgressOnly } = this.state;
    const start_time = `${startDate} 00:00:00`;
    const end_time = `${endDate} 00:00:00`;

    const url = await req.assessmentExport({
      id,
      with_progress_only: withProgressOnly,
      start_time,
      end_time
    });

    newWindow.location = url;
    this.props.onClose(this.props.data);
  };

  render() {
    const { withProgressOnly, startDate, endDate, error } = this.state;

    return (
      <div className="modal__wrapper view-profile">
        <div className="modal__header modal__header--bordered">
          <span className="modal__header-title view-profile__title">View Portfolio</span>
          <div className="view-profile__sub-title">
            Filter this child’s portfolio to export only information within the specified date range.
          </div>
        </div>

        <div className="modal__container view-profile__body">
          <div className="view-profile__date-filter-row" style={{ marginBottom: 16 }}>
            <div className="datepicker-container">
              <div className="datepicker-label">
                Start Date<span className="form__asterisk">*</span>
              </div>
              <DatePicker
                value={startDate ? moment(startDate).toDate() : ''}
                placeholder="Start Date"
                disabled={false}
                onChange={this.onStartDateChange}
                disableFuture
                disableDays={this.disableDaysStart}
              />
            </div>
            <div className="datepicker-container">
              <div className="datepicker-label">
                End Date<span className="form__asterisk">*</span>
              </div>
              <DatePicker
                value={endDate ? moment(endDate).toDate() : ''}
                placeholder="End Date"
                disabled={false}
                onChange={this.onEndDateChange}
                disableFuture
                disableDays={this.disableDays}
              />
              {error ? (
                <div className="datepicker-error">{error}</div>
              ) : (
                <div className="datepicker-info">Cannot exceed 6 months from Start Date</div>
              )}
            </div>
          </div>

          <div className="view-profile__checkbox-row">
            <Checkbox
              className="view-profile__checkbox"
              checked={withProgressOnly}
              onChange={this.checkChanged}
              label="Only include Assessments with an assigned Progress"
            />
          </div>
        </div>

        <div className="modal__controls">
          <ButtonV2 primary label="View" onClick={this.onExport} />
        </div>
      </div>
    );
  }
}

export default ViewPortfolioV2;
